<template>
    <va-create-layout>
        <FinancialEvent-form :title="title" :item="item"></FinancialEvent-form>
    </va-create-layout>
</template>

<script>
export default {
    props: ["title", "item"],
};
</script>
